import instance from './instance';

export default {
  async GET(endPoint, config = {}) {
    try {
      const res = await instance.get(endPoint, config);
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async POST(url, params, config) {
    try {
      const res = await instance.post(url, params, config);
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  },
};
